import {createContext} from 'react';
import type {CompanyState, CompanyActions} from './types';

export const CompanyConfigContext = createContext<CompanyState>(null as unknown as CompanyState);

export const CompanyConfigDispatchContext = createContext<React.Dispatch<CompanyActions>>(
  null as unknown as React.Dispatch<CompanyActions>,
);
